import AcidyAudio from '../../../../../audio/acidy-sound.mp3';

export default class Acidy {
    static init() {
        let acidyClickCount = 0;
        let clickTimeout;
        document.querySelector('.scroll-wheel').addEventListener('click', () => {
            clearTimeout(clickTimeout);
            acidyClickCount++;

            clickTimeout = setTimeout(() => {
                acidyClickCount = 0;
            }, 500);
            // Active when 3 clicks
            if (acidyClickCount === 3) {
                clearTimeout(clickTimeout);
                acidyClickCount = 0;

                document.getElementById('acidy').style.opacity = '100%';
                document.getElementById('acidy').style.left = 'calc(100vw - 300px)';
                document.getElementById('acidy').classList.add('bounce-acidy');
                (new Audio(AcidyAudio)).play();
                setTimeout(() => {
                    document.getElementById('acidy').classList.remove('bounce-acidy');
                }, 1100);
                // Rolling back Acidy
                setTimeout(() => {
                    document.getElementById('acidy').style.left = '100vw';
                    document.getElementById('acidy').classList.add('bounce-acidy');
                    setTimeout(() => {
                        document.getElementById('acidy').style.opacity = '0';
                    }, 1500);
                }, 2000);
            }
        });
    }
}
